module.exports = __webpack_public_path__ + "img/look.08114bd9.jpg";